import * as React from 'react';
import style from './Button.scss';
import classnames from 'classnames';
import { Text } from '../../PageElements/Text';

interface ButtonProps {
  children: React.ReactNode;
  dataHook?: string;
  disabled?: boolean;
  skin?: 'secondary';
  className?: string;
  [additionalProps: string]: any;
  size?: 'tiny' | 'small';
  as?: keyof HTMLElementTagNameMap;
}

export const Button = ({
  children,
  dataHook,
  disabled,
  skin,
  className,
  size = 'small',
  as = 'button',
  ...restOfProps
}: ButtonProps) => {
  return React.createElement(
    as,
    {
      disabled,
      'data-hook': dataHook,
      className: classnames({
        [style.disabled]: disabled,
        [style.btn]: true,
        [style[skin]]: true,
        [style[size]]: true,
        [className]: true,
      }),
      ...restOfProps,
    },
    typeof children === 'string' ? (
      <Text tagName="span" weight="normal" size={size}>
        {children}
      </Text>
    ) : (
      children
    ),
  );
};
